export const getTemplateCategories = (
  base_path: string,
  template_counts: TemplateCounts | null = null,
): TemplateCategory[] => {
  let categories = [
    {
      label: "Application forms",
      longLabel: "Application form templates",
      shortLabel: "Application",
      value: "application-forms",
      gradient:
        "linear-gradient(45deg, rgb(81 174 222), rgb(119 173 249), rgb(93 144 245))",
      display_description:
        "Wide range of comprehensive application templates. Packed with advanced features like multi-step layout, save-and-resume, partial submissions, and more.",
      seo_title: "Professional Application Form Templates",
      seo_description:
        "Explore our free application form templates to streamline job, volunteer, grant, and scholarship application processes.",
      internal:
        "This can cover job applications, volunteer applications, grant applications, and scholarship forms.",
      items: [
        {
          label: "Employment",
          longLabel: "Employment application form templates",
          shortLabel: "Employment",
          seo_title: "Employment Application Form Templates",
          display_description:
            "Streamline your hiring process with our free job application form templates.",
          seo_description:
            "Streamline your hiring process with our free job application form templates. Customize them to match your brand and collect candidate information online. Includes job application, internship application, volunteer application, etc ...",
          value: "employment-application-forms",
        },
        {
          label: "Finance",
          longLabel: "Finance application form templates",
          shortLabel: "Finance",
          seo_title: "Finance Application Form Templates",
          display_description:
            "Process applications for loans, credit cards, and other financial products.",
          seo_description:
            "Form templates to simplify the finance application processes for individuals and businesses.",
          value: "finance-application-forms",
        },
        {
          label: "Education",
          longLabel: "Education application form templates",
          shortLabel: "Education",
          seo_title: "Education Application Form Templates",
          display_description:
            "Free education application form templates to simplify enrollments and registrations.",
          seo_description:
            "Create free education application forms to simplify the enrollment process for schools and universities.",
          value: "education-application-forms",
        },
        {
          label: "Government and public",
          longLabel: "Government and public services templates",
          shortLabel: "Public",
          seo_title:
            "Government and Public Services Application Form Templates",
          display_description: "Simplify the application process for citizens.",
          seo_description:
            "Free government and public services form templates to simplify the application process for citizens. Including passport, visa, and driver's license applications.",
          value: "government-application-forms",
        },
        {
          label: "Business and legal",
          longLabel: "Business and legal application form templates",
          shortLabel: "Business",
          seo_title: "Business and Legal Application Form Templates",
          display_description:
            "Templates to simplify the business and legal application processes.",
          seo_description:
            "Free form templates to simplify the business and legal application processes.",
          value: "business-and-legal-application-forms",
        },
        {
          label: "Rental and housing",
          longLabel: "Rental and housing application form templates",
          shortLabel: "Rental",
          seo_title: "Rental and Housing Application Form Templates",
          display_description:
            "Templates to collect and process rental and housing applications.",
          seo_description:
            "Form templates to simplify the rental and housing application process for landlords, property managers, and others. Including rental application, roommate application, car rental, and more.",
          value: "rental-and-housing-application-forms",
        },
        {
          label: "General",
          longLabel: "General application form templates",
          shortLabel: "General",
          seo_title: "General Application Form Templates",
          display_description:
            "Versatile application form templates which can be adapted for various use cases.",
          seo_description:
            "General purpose application form templates to simplify the application process for individuals and businesses, like adoption application, volunteer application, grant application, scholarship application, etc ...",
          value: "general-application-forms",
        },
      ],
    },
    {
      label: "Calculation forms",
      longLabel: "Calculation form templates",
      shortLabel: "Calculation",
      value: "calculation-forms",
      gradient: "linear-gradient(45deg, rgb(132 192 62), rgb(54, 186, 170))",
      display_description:
        "Templates that use advanced math calculations for quotations, estimations, budgets, and more.",
      seo_title: "Unique Calculation Form Templates",
      seo_description:
        "Discover a wide range of calculation form templates for quotes, loans, and taxes, designed for accuracy and ease of use. From simple to complex.",
      items: [
        {
          label: "Planning and budgeting",
          longLabel: "Planning and budget calculation templates",
          shortLabel: "Budget",
          seo_title: "Planning and Budget Calculation Templates",
          display_description:
            "Create cost and budget estimations based on live input.",
          seo_description:
            "Planning and budgeting form templates to create cost and budget estimatons based on live input, including event costs, study expenses, etc ...",
          value: "planning-and-budget-calculation-forms",
        },
        {
          label: "Housing and finance",
          longLabel: "Housing and financial calculation templates",
          shortLabel: "Finance",
          seo_title: "Housing and Financial Calculation Templates",
          display_description:
            "Offer financial planning and analysis using advanced math calculations in forms.",
          seo_description:
            "Use our financial calculation form templates for precise financial planning and analysis, including retirement savings, investment returns, and budget planning.",
          value: "housing-and-finance-calculation-forms",
        },
      ],
    },
    {
      label: "Lead generation forms",
      longLabel: "Lead generation form templates",
      shortLabel: "Leads",
      value: "lead-generation-forms",
      gradient:
        "linear-gradient(45deg, rgb(226 129 89), rgb(255 126 60), rgb(255 41 17))",
      display_description:
        "High-converting forms to capture qualified leads. Integrate with HubSpot, Salesforce, and more.",
      seo_title: "Popular Lead Generation Form Templates",
      seo_description:
        "Explore Formcrafts' extensive range of lead generation form templates for general inquiries, lead generation, press inquiries, quotation request, content access, and more.",
      internal:
        "Essential for business websites, these forms can range from simple contact us forms to more complex ones with department-specific queries. General inquiry, lead generation, press inquiry, etc ...",
      items: [
        {
          label: "Sales and demo",
          longLabel: "Sales and demo request form templates",
          shortLabel: "Sales",
          seo_title: "Sales and Demo Request Form Templates",
          display_description:
            "Templates for sales inquiries and demo requests.",
          seo_description:
            "Sales inquiry and demo request form templates to streamline the sales inquiry process for businesses and organizations.",
          value: "sales-and-demo-request-forms",
        },
        {
          label: "Quotation request",
          longLabel: "Quotation request form templates",
          shortLabel: "Quotation",
          seo_title: "Quotation Request Form Templates",
          display_description:
            "Let customers easily submit quote requests with these well-designed and powerful templates.",
          seo_description:
            "Wide range of quotation request form templates to improve the quotation process for businesses and organizations.",
          value: "quotation-request-forms",
        },
        {
          label: "Content request",
          longLabel: "Content request form templates",
          shortLabel: "Content",
          seo_title: "Content Request Form Templates",
          display_description:
            "Offer valuable content, like eBooks, whitepapers, and PDFs, in exchange for contact information.",
          seo_description:
            "Content request form templates to generate leads by offering valuable content in exchange for contact information, like whitepaper download, ebook download, software trial, etc ...",
          value: "content-request-forms",
        },
        {
          label: "Email signup",
          longLabel: "Email signup form templates",
          shortLabel: "Email",
          seo_title: "Email Signup Form Templates",
          display_description:
            "Simplify your email signup process with these embeddable templates. Integrates with Mailchimp, HubSpot, ActiveCampaign, and more.",
          seo_description:
            "Email signup form templates to streamline the newsletter signup process for businesses and organizations.",
          value: "email-signup-forms",
        },
        {
          label: "General inquiry",
          longLabel: "General inquiry form templates",
          shortLabel: "General",
          seo_title: "General Inquiry Form Templates",
          display_description:
            "Versatile templates to streamline the inquiry process for businesses.",
          seo_description:
            "General inquiry form templates to streamline the inquiry process for businesses and organizations.",
          value: "contact-us-forms",
        },
      ],
    },
    {
      label: "Customer service",
      longLabel: "Customer service form templates",
      shortLabel: "Customer",
      value: "customer-service-forms",
      gradient:
        "linear-gradient(90deg, #42a970, #49aa66, #51aa5c, #5aab51, #64ab45, #6eab38, #79aa29, #84a916)",
      seo_title: "Versatile Customer Service Form Templates",
      display_description:
        "Optimize customer service with these form templates. Integrates with Zendesk, HubSpot, Salesforce, and more.",
      seo_description:
        "Explore Formcrafts' extensive range of customer service form templates for dealing with support requests, bug reports, warranty claims, refund requests, etc ...",
      internal:
        "These forms can include support request forms, bug report forms, and refund request forms, warranty claim, service dispute, issue reporting.",
      items: [
        {
          label: "Support request",
          longLabel: "Support request form templates",
          shortLabel: "Support",
          seo_title: "Support Request Form Templates",
          display_description:
            "Allow customers to submit support requests easily. Integrates with Zendesk, Freshdesk, and more.",
          seo_description:
            "Diverse support request form templates to optimize customer service and streamline issue resolution.",
          value: "support-request-forms",
        },
        {
          label: "Refund and exchange",
          longLabel: "Refund and exchange form templates",
          shortLabel: "Refund",
          seo_title: "Refund and Exchange Form Templates",
          display_description:
            "Allow customers to request refunds and exchanges.",
          seo_description:
            "Form templates for handling refunds and exchanges to improve customer service handling.",
          value: "refund-and-exchange-forms",
        },
        {
          label: "Complaint and report",
          longLabel: "Complaint and report form templates",
          shortLabel: "Report",
          seo_title: "Complaint and Report Form Templates",
          display_description:
            "Allow customers to file complaints and report issues.",
          seo_description:
            "Free complaint, report, and issue filing form templates to gather customer concerns and improve customer service.",
          value: "complaint-forms",
        },
        {
          label: "Account management",
          longLabel: "Account management form templates",
          shortLabel: "Account",
          seo_title: "Account Management Form Templates",
          display_description:
            "Facilitate seamless customer communication and account management.",
          seo_description:
            "Free account management form templates to facilitate seamless customer communication and account management.",
          value: "account-management-forms",
        },
      ],
    },
    {
      label: "Evaluation forms",
      longLabel: "Evaluation form templates",
      shortLabel: "Evaluation",
      gradient: "linear-gradient(25deg, #943df2, #506eef)",
      display_description:
        "Conduct in-depth evaluations with these easy-to-use form template.",
      seo_title: "Comprehensive Evaluation Form Templates",
      seo_description:
        "Explore Formcrafts' extensive range of evaluation form templates for thorough employee assessments and event feedback collection.",
      value: "evaluation-forms",
      items: [
        {
          label: "General",
          longLabel: "Evaluation form templates",
          shortLabel: "General",
          seo_title: "General Evaluation Form Templates",
          display_description:
            "Versatile evaluation form templates for various use cases.",
          seo_description:
            "General evaluation form templates for various use cases, like event evaluation, product evaluation, service evaluation, etc ...",
          value: "general-evaluation-forms",
        },
        {
          label: "Performance",
          longLabel: "Performance evaluation form templates",
          shortLabel: "Performance",
          seo_title: "Performance Evaluation Form Templates",
          display_description:
            "Supercharge your performance reviews and employee evaluations.",
          seo_description:
            "Free and custom performance evaluation form templates. Includes Employee Year-End Performance Review Form",
          value: "performance-evaluation-forms",
        },
        {
          label: "Operational",
          longLabel: "Operational assessment form templates",
          shortLabel: "Operational",
          seo_title: "Operational Assessment Form Templates",
          display_description:
            "Evaluate your programs, policies, and quality with these forms.",
          seo_description:
            "Free operational assessment form templates, covering programs, policy, and quality assessment. Includes non-profit program impact, organizational policy compliance, etc ...",
          value: "operational-assessment-forms",
        },
        {
          label: "Risk and compliance",
          longLabel: "Risk and compliance review form templates",
          shortLabel: "Risk",
          seo_title: "Risk and Compliance Review Form Templates",
          display_description:
            "Evaluate risk and compliance with these comprehensive forms.",
          seo_description:
            "Form templates for risk and compliance reviews. Includes risk assessment, workplace risk, financial risk, compliance audit, and more.",
          value: "risk-and-compliance-forms",
        },
        {
          label: "Education",
          longLabel: "Education and research evaluation templates",
          shortLabel: "Education",
          seo_title: "Education and Research Evaluation Templates",
          display_description:
            "Evaluate student performance, curriculum, and research with these forms.",
          seo_description:
            "Education and research evaluation form templates. Includes student evaluation, curriculum evaluation, course evaluation, research evaluation, and more.",
          value: "education-and-research-evaluation-forms",
        },
      ],
    },
    {
      label: "Survey and feedback",
      longLabel: "Survey and feedback templates",
      shortLabel: "Survey",
      value: "survey-and-feedback-forms",
      gradient:
        "linear-gradient(120deg, rgb(118 144 252), rgb(87 138 226), rgb(71 146 206))",
      seo_title: "Creative Survey and Feedback Templates",
      display_description:
        "Creative survey and feedback form templates to gather valuable insights.",
      seo_description:
        "Creative survey and feedback form templates to gather valuable customer insights. Includes employee surveys, product feedback, service feedback, event evaluation, and more.",
      internal:
        "This category can include customer feedback forms, employee surveys, market research questionnaires, and event evaluation forms.",
      items: [
        {
          label: "Customer experience",
          longLabel: "Customer experience surveys",
          shortLabel: "CX",
          seo_title: "Customer Experience Survey Templates",
          display_description:
            "Gather customer feedback and improve customer service with these customer experience (CX) surveys.",
          seo_description:
            "Free customer experience (CX) form templates to gather customer feedback and improve customer service.", // Like Post-Purchase Feedback, Service Experience Survey, Product Usability Feedback, Customer Loyalty and Retention Survey
          value: "customer-experience",
        },
        {
          label: "Product and service",
          longLabel: "Product and service feedback form templates",
          shortLabel: "Product",
          seo_title: "Product and Service Feedback Templates",
          display_description:
            "Capture honest customer opinions and enhance product quality.",
          seo_description:
            "Wide selection of product and service feedback form templates to capture honest customer opinions and enhance product quality.", // Beta testing feedback form, new feature evaluation survey, product improvement suggestion form
          value: "product-and-service-feedback-forms",
        },
        {
          label: "Event and program",
          longLabel: "Event and program feedback templates",
          shortLabel: "Event",
          seo_title: "Event and Program Feedback Templates",
          display_description: "Get feedback on events and programs.",
          seo_description:
            "Wide selection of event feedback form templates to gather valuable insights from visitors and improve event planning and management.", // Post-Event Feedback Speaker Evaluation Form Attendee Satisfaction Survey Event Organization Feedback
          value: "event-feedback-forms",
        },
        {
          label: "Market research",
          longLabel: "Market research form templates",
          shortLabel: "Market research",
          seo_title: "Optimized Market Research Form Templates",
          display_description:
            "Templates to conduct thorough market research and understand consumer behavior.",
          seo_description:
            "Form templates to help you conduct market research and gather valuable consumer insights.", // Product Concept Testing Brand Awareness Survey Target Market Analysis Pricing Strategy Feedback
          value: "market-research-forms",
        },
        {
          label: "Workplace",
          longLabel: "Workplace feedback and survey templates",
          shortLabel: "Workplace",
          seo_title: "Workplace Feedback and Survey Templates",
          display_description:
            "Gather feedback from employees and improve workplace satisfaction.",
          seo_description:
            "Workplace feedback and survey templates to gather employee feedback and improve employee satisfaction, like employee satisfaction survey, Workplace survey, employee exit survey, etc ...", // Employee Satisfaction Survey, Performance Evaluation Feedback, Workplace Environment Survey, Training and Development Feedback
          value: "workplace-feedback-and-surveys",
        },
      ],
    },
    {
      label: "Operations forms",
      longLabel: "Operations form templates",
      shortLabel: "Internal",
      value: "internal-forms",
      gradient: "linear-gradient(145deg, #cd54a8, #ce66af, #ed6060)",
      seo_title: "Efficient Operations Form Templates",
      display_description:
        "Streamline internal operations with these form templates.",
      seo_description:
        "Explore Formcrafts' extensive range of operations form templates for employee onboarding, leave requests, expense reimbursements, and more.",
      internal:
        "Useful for copy change request, campaign redesign, content approval, sevice request, software installation, network access, and more.",
      items: [
        {
          label: "General operations",
          longLabel: "General operations form templates",
          shortLabel: "General",
          seo_title: "General Operations Form Templates",
          display_description:
            "Versatile form templates to streamline internal operations.",
          seo_description:
            "General operations form templates to streamline internal operations and improve efficiency.",
          value: "general-internal-forms",
        },
        {
          label: "Marketing and communications",
          longLabel: "Marketing and communications form templates",
          shortLabel: "Marketing",
          seo_title: "Marketing and Communications Form Templates",
          display_description:
            "Templates for marketing and communications requests.",
          seo_description:
            "Free marketing and communications form templates to streamline internal operations and improve efficiency.",
          value: "marketing-and-communications-forms",
        },
        {
          label: "Human resources",
          longLabel: "Human resources form templates",
          shortLabel: "HR",
          seo_title: "Human Resources Form Templates",
          display_description:
            "Templates for HR requests like leave requests and expense reimbursements.",
          seo_description:
            "Selection of human resources form templates like leave requests, expense reimbursements, and more to simplify internal operations.",
          value: "hr-forms",
        },
        {
          label: "IT and technical",
          longLabel: "IT and technical support form templates",
          shortLabel: "IT",
          seo_title: "IT and Technical Support Form Templates",
          display_description:
            "Templates for IT and technical support requests.",
          seo_description:
            "Form templates to streamline IT and technical support requests and improve internal operations.",
          value: "it-and-technical-support-forms",
        },
        {
          label: "Facilities and maintenance",
          longLabel: "Facilities and maintenance form templates",
          shortLabel: "Maintenance",
          seo_title: "Facilities and Maintenance Form Templates",
          display_description:
            "Templates for facilities and maintenance requests.",
          seo_description:
            "Form templates to streamline facilities and maintenance requests and improve internal operations.",
          value: "maintenance-forms",
        },
        {
          label: "Finance and procurement",
          longLabel: "Finance and procurement form templates",
          shortLabel: "Finance",
          seo_title: "Finance and Procurement Form Templates",
          display_description:
            "Templates for finance and procurement requests.",
          seo_description:
            "Form templates to streamline finance and procurement requests and improve internal operations.",
          value: "finance-and-procurement-forms",
        },
        {
          label: "Healthcare",
          longLabel: "Healthcare form templates",
          shortLabel: "Healthcare",
          seo_title: "Healthcare Form Templates",
          display_description:
            "Templates for healthcare requests like patient intake and appointment scheduling.",
          seo_description:
            "Form templates to streamline healthcare requests and improve internal operations.",
          value: "healthcare-forms",
        },
      ],
    },
    {
      label: "Payment forms",
      longLabel: "Payment form templates",
      shortLabel: "Payment",
      value: "payment-forms",
      gradient: "linear-gradient(90deg, #56b2a0, #57b39f, #1bb8b9)",
      display_description:
        "Accept one-time or recurring payments and donations with these secure payment form templates, using Stripe.",
      seo_title: "Secure Payment Form Templates",
      seo_description:
        "Free payment form templates to accept orders and subscriptions with ease. Includes donation forms, product order forms, subscription forms, and more.",
      internal:
        "Useful for e-commerce sites, restaurants, and service providers. They can include product order forms, table reservation forms, and appointment booking forms.",
      items: [
        {
          label: "Product order form",
          longLabel: "Product order form templates",
          shortLabel: "Product",
          seo_title: "Product Order Form Templates",
          display_description: "Allow visitors to order products online.",
          seo_description:
            "Form templates that allow visitors to order products online. Includes product order forms, product customization forms, and more.",
          value: "product-order-forms",
        },
        {
          label: "Subscription form",
          longLabel: "Subscription form templates",
          shortLabel: "Subscription",
          seo_title: "Subscription Form Templates",
          display_description:
            "Collect recurring payments from your customers with these subscription form templates.",
          seo_description:
            "Free subscription form templates to collect recurring payments and manage subscriptions online.",
          value: "subscription-forms",
        },
        {
          label: "Service payment form",
          longLabel: "Service payment form templates",
          shortLabel: "Service",
          seo_title: "Service Payment Form Templates",
          display_description:
            "Allow customers to pay for your services online.",
          seo_description:
            "Free service payment form templates to collect payments for services online.",
          value: "service-payment-forms",
        },
      ],
    },
    {
      label: "Booking and registration",
      longLabel: "Booking and registration form templates",
      shortLabel: "Booking",
      value: "booking-and-registration-forms",
      gradient:
        "linear-gradient(90deg, #de8a2f, #f17852, #f56b76, #e96a9a, #cf72b9, #a87ece, #7888d6, #3f8fd1)",
      seo_title: "Innovative Booking and Registration Form Templates",
      display_description:
        "Use these templates to allow visitors to book appointments, register for events, and more.",
      seo_description:
        "Explore Formcrafts' extensive range of registration form templates for events, classes, and workshops. Includes event registration forms, class registration forms, and more.",
      items: [
        {
          label: "General",
          longLabel: "General booking and registration templates",
          shortLabel: "General",
          seo_title: "General Booking and Registration Templates",
          display_description:
            "Versatile booking and registration templates for things like venue booking, table reservation, and more.",
          seo_description:
            "General booking and form templates for things like venue booking, table reservation, and more.",
          value: "general-booking-and-registration-forms",
        },
        {
          label: "Events",
          longLabel: "Event booking form templates",
          shortLabel: "Events",
          seo_title: "Event Booking Form Templates",
          display_description:
            "Allow visitors to register for events and workshops with these templates.",
          seo_description:
            "Curated event booking and booking form templates to simplify event planning and management.",
          value: "event-booking-forms",
        },
        {
          label: "Education",
          longLabel: "Education form templates",
          shortLabel: "Education",
          seo_title: "Education Registration Form Templates",
          display_description:
            "Allow students to register for classes and workshops with these templates.",
          seo_description:
            "Education form templates for schools, universities, and other educational institutions.",
          value: "education-registration-forms",
        },
        {
          label: "Services",
          longLabel: "Service booking form templates",
          shortLabel: "Service",
          seo_title: "Service Booking Form Templates",
          display_description: "Allow customers to book services online.",
          seo_description:
            "Service booking form templates for appointment scheduling, including medical, dental, and beauty services.",
          value: "service-booking-forms",
        },
        {
          label: "Travel and leisure",
          longLabel: "Travel and leisure form templates",
          shortLabel: "Travel",
          seo_title: "Travel and Leisure Booking Form Templates",
          display_description:
            "Templates to allow customers to book travel services.",
          seo_description:
            "Free travel and leisure booking form templates for hotels, flights, and other travel services.",
          value: "travel-booking-forms",
        },
      ],
    },
    {
      label: "Salesforce forms",
      longLabel: "Salesforce form templates",
      shortLabel: "Salesforce",
      gradient: "linear-gradient(90deg, #009ddb, #009ddb)",
      display_description:
        "Forms that integrate with Salesforce to create or update records.",
      seo_title: "Salesforce Form Templates",
      seo_description:
        "Explore our Salesforce form templates to streamline your sales and marketing processes.",
      value: "salesforce-forms",
      items: [
        {
          label: "Lead capture",
          longLabel: "Salesforce lead capture form templates",
          shortLabel: "Leads",
          seo_title: "Salesforce Lead Capture Form Templates",
          display_description:
            "Create contact us and lead capture forms (like web-to-lead) that integrate with Salesforce.",
          seo_description:
            "Lead capture form templates to capture leads and integrate with Salesforce CRM.",
          value: "salesforce-lead-generation-forms",
          // lead capture, newsletter, quote request
        },
        {
          label: "Application forms",
          longLabel: "Salesforce application form templates",
          shortLabel: "Application",
          seo_title: "Salesforce application Form Templates",
          display_description:
            "Create application forms that integrate with Salesforce CRM.",
          seo_description:
            "Application form templates to streamline the application process and integrate with Salesforce CRM.",
          value: "salesforce-application-forms",
          // job application
        },
        {
          label: "Surveys",
          longLabel: "Salesforce survey form templates",
          shortLabel: "Surveys",
          seo_title: "Salesforce Survey Form Templates",
          display_description:
            "Create customer surveys (like CSAT) that integrate with Salesforce.",
          seo_description:
            "Survey form templates to collect customer feedback and integrate with Salesforce CRM.",
          value: "salesforce-surveys",
          // csat, nps, customer feedback
        },
        {
          label: "Customer support",
          longLabel: "Salesforce customer support form templates",
          shortLabel: "Support",
          seo_title: "Salesforce Customer Support Form Templates",
          display_description:
            "Create customer support forms (like web-to-case) that integrate with Salesforce.",
          seo_description:
            "Customer support form templates to streamline customer support and integrate with Salesforce CRM.",
          value: "salesforce-customer-support-forms",
          // support ticket, product return, exchange, complaint
        },
        {
          label: "General",
          longLabel: "Salesforce general form templates",
          shortLabel: "Support",
          seo_title: "General Salesforce Form Templates",
          display_description:
            "Create forms that integrate with Salesforce CRM to streamline various processes.",
          seo_description:
            "General form templates to streamline various processes and integrate with Salesforce CRM.",
          value: "salesforce-general-forms",
          // contact us, feedback, general inquiry
        },
      ],
    },
    {
      label: "Other forms",
      longLabel: "Other form templates",
      shortLabel: "Other",
      gradient: "linear-gradient(90deg, #495b6d, #4e5d81)",
      display_description: "Unique and specialized form templates.",
      seo_title: "Unique and Specialized Form Templates",
      seo_description:
        "Explore our unique and specialized form templates for a variety of purposes, beyond standard form categories.",
      value: "other-forms",
      items: [
        {
          label: "Quiz and trivia",
          longLabel: "Quiz and trivia form templates",
          shortLabel: "Quiz",
          seo_title: "Quiz and Trivia Form Templates",
          display_description:
            "Create interactive quizzes and trivia games with these templates. Use math calculations to score answers.",
          seo_description:
            "Quiz and trivia form templates to create interactive quizzes and trivia games for fun and education.",
          value: "quiz-and-trivia-forms",
        },
        {
          label: "Consent forms",
          longLabel: "Consent form templates",
          shortLabel: "Consent",
          display_description:
            "Comprehensive consent form templates, including medical consent, cookie consent, research consent, privacy consent, terms of service agreement, and more.",
          seo_title: "Consent Form Templates",
          seo_description:
            "Comprehensive consent form templates, including medical consent, cookie consent, research consent, privacy consent, terms of service agreement, and more.",
          value: "consent-forms",
        },
        {
          label: "Content submission",
          longLabel: "Content submission form templates",
          shortLabel: "Content submission",
          seo_title: "Content Submission Form Templates",
          display_description:
            "Allow visitors to submit content like articles, photos, and videos.",
          seo_description:
            "Content submission form templates to streamline the content submission process for writers, photographers, and other creatives.",
          value: "content-submission-forms",
        },
      ],
    },
  ];

  const result = categories.map((category) => {
    return {
      ...category,
      icon: `${base_path}/images/svg/form-templates/${category.value}.svg`,
      count: template_counts?.categories?.[category.value] ?? 0,
      items: category.items.map((item) => {
        return {
          ...item,
          count: template_counts?.subcategories?.[item.value] ?? 0,
        };
      }),
    };
  });

  return result;
};
